import React from 'react'
import { useNavigate } from 'react-router-dom'
import useSessionStore from '../store/sessionStore'
import Card from '../components/ui/Card'
import styles from './SelectType.module.css'

const TYPES = [
  {
    key: 'id',
    title: 'ID Document',
    desc: 'Passport, driver license, or government-issued ID.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="10" r="2" stroke="currentColor" strokeWidth="2" />
        <path d="M8 16c0-2 2-3 4-3s4 1 4 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: 'selfie',
    title: 'Selfie Photo',
    desc: 'A clear photo of your face for identity matching.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
        <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: 'video',
    title: 'Verification Video',
    desc: 'A short video following the verification instructions.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="6" width="15" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
        <path d="M17 10l5-3v10l-5-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
]

export default function SelectType() {
  const navigate = useNavigate()
  const setSelectedType = useSessionStore((s) => s.setSelectedType)

  const handleSelect = (type) => {
    setSelectedType(type)
    navigate('/select-method')
  }

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>What do you need to verify?</h1>
        <p className={styles.sub}>Select the type of verification document required.</p>
        <div className={styles.grid} role="list">
          {TYPES.map((t) => (
            <button
              key={t.key}
              className={styles.cardButton}
              onClick={() => handleSelect(t.key)}
              aria-label={`Select ${t.title}`}
              role="listitem"
            >
              <Card padding="lg" className={styles.card}>
                <div
                  className={[styles.iconWrap, styles[`iconWrap${t.key.charAt(0).toUpperCase() + t.key.slice(1)}`]].join(' ')}
                  aria-hidden="true"
                >
                  {t.icon}
                </div>
                <h2 className={styles.cardTitle}>{t.title}</h2>
                <p className={styles.cardDesc}>{t.desc}</p>
              </Card>
            </button>
          ))}
        </div>
      </div>
    </main>
  )
}
